// extracted by mini-css-extract-plugin
export var Footer = "footer-module--Footer--10NqO";
export var Footer__content = "footer-module--Footer__content--2L9xo";
export var Footer__rss = "footer-module--Footer__rss--31Vyq";